import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useCrudForm } from "../common/crudForm/useCrudForm";
import { CrudFormLayout, Field } from "../common/crudForm/crudFormLayout";
import { useAuth } from "../../AuthContext";
import { getPresupuesto, savePresupuesto } from "../../services/presupuestosService";
import { getMovimientosPresupuestos } from "../../services/cajasDomoService.js";
import { personasPromiseOptions, getPersona, getPersonasSelect } from "../../services/personasService";
import {
  proyectosPromiseOptions,
  getSubProyectos,
  getProyecto,
  getProyectosSelect,
} from "../../services/proyectosService";
import {
  estadosPresupuestos,
  formatCurrencyToFloat,
  formattedToFloat,
  numberWithCommas,
  formasPago,
} from "../utils/utils";
import { getMonedasSimboloSelect } from "../../services/monedasService.js";
import { getCategoriasSelect } from "../../services/categoriasService.js";

import FileBrowser from "../fileBrowser/fileBrowser";
import ChildArray from "../common/childArray";

import ReactTabHotkeyReplacer from "react-tab-hotkey-replacer/dist/ReactTabHotkeyReplacer";
import { OverlayTrigger, Tooltip, Accordion } from "react-bootstrap";

import Joi from "joi";
import moment from "moment";
import { getConfig } from "../../config/config.js";

export default function PresupuestosForm(props) {
  const history = useHistory();
  const { selectedModule } = useAuth();
  const config = getConfig();

  const serviceFolder = "presupuestos";
  const filesUrl = config.filesUrl + "/presupuestos/";

  const onCancel = props.onCancel;
  const title = "Presupueseto";
  const subTitle = "Detalles";

  const [subproyectos, setSubproyectos] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [monedas, setMonedas] = useState([]);
  const [movimientos, setMovimientos] = useState([]);
  const [perc, setPerc] = useState(0);
  const [percIva, setPercIva] = useState(0);

  const breadcrumbs = [
    {
      title: "Inicio",
      link: "/main",
    },
    {
      title: "Presupuestos",
      link: "/presupuestos",
    },
    {
      title: "Detalles",
    },
  ];

  const initialData = {
    proyecto: "",
    subproyecto: "",
    categoria: "",
    contratista: "",
    descripcion: "",
    estado: "",
    moneda: "",
    adicionales: [
      {
        fecha: moment().format("YYYY-MM-DD"),
        detalle: "Presupuesto Original",
        monto: 0,
      },
    ],
    archivos: [],
    iva: 0,
  };

  const schema = Joi.object({
    _id: Joi.string(),
    descripcion: Joi.string().label("Descripcion").required().messages({
      "string.empty": "Debe ingresar una descripcion",
    }),
    estado: Joi.any()
      .required()
      .custom((value, helpers) => {
        if (!value || !value.label || !value.value) {
          return helpers.error("any.invalid");
        }
        return value;
      })
      .label("Moneda")
      .messages({
        "any.required": "Debe ingresar un estado", // undefined
        "any.invalid": "Debe ingresar un estado", // null / empty props
      }),
    moneda: Joi.any()
      .required()
      .custom((value, helpers) => {
        if (!value || !value.label || !value.value) {
          return helpers.error("any.invalid");
        }
        return value;
      })
      .label("Moneda")
      .messages({
        "any.required": "Debe ingresar una moneda", // undefined
        "any.invalid": "Debe ingresar unda moneda", // null / empty props
      }),
    categoria: Joi.any()
      .required()
      .custom((value, helpers) => {
        if (!value || !value.label || !value.value) {
          return helpers.error("any.invalid");
        }
        return value;
      })
      .label("Categoria")
      .messages({
        "any.required": "Debe ingresar una categoria", // undefined
        "any.invalid": "Debe ingresar unda categoria", // null / empty props
      }),
    contratista: Joi.any()
      .required()
      .custom((value, helpers) => {
        if (!value || !value.label || !value.value) {
          return helpers.error("any.invalid");
        }
        return value;
      })
      .label("Contratista")
      .messages({
        "any.required": "Debe ingresar una contratista", // undefined
        "any.invalid": "Debe ingresar unda contratista", // null / empty props
      }),
  });

  const adicionalesFormat = [
    { label: "Fecha", width: "20%", column: "fecha", type: "date" },
    { label: "Detalle", width: "50%", column: "detalle", type: "text" },
    {
      label: "Monto",
      width: "25%",
      column: "monto",
      type: "number",
      showWithCommas: "true",
    },
  ];

  const adicional = {
    fecha: moment().format("YYYY-MM-DD"),
    detalle: "",
    monto: 0,
  };

  const transformBeforeSave = (record) => {
    record.iva = formatCurrencyToFloat(record.iva);
    if (record.adicionales) {
      record.adicionales.map((adicional) => {
        adicional.monto = formattedToFloat(adicional.monto);
      });
    }
    if (record.estado && typeof record.estado === "object" && record.estado.value) record.estado = record.estado.value;
    if (record.proyecto && typeof record.proyecto === "object" && record.proyecto.value)
      record.proyecto = record.proyecto.value;
    if (record.moneda && typeof record.moneda === "object" && record.moneda.value) record.moneda = record.moneda.value;
    if (record.categoria && typeof record.categoria === "object" && record.categoria.value)
      record.categoria = record.categoria.value;
    if (record.contratista && typeof record.contratista === "object" && record.contratista.value)
      record.contratista = record.contratista.value;
    if (record.subproyecto && typeof record.subproyecto === "object" && record.subproyecto.value)
      record.subproyecto = record.subproyecto.value;
    else delete record.subproyecto;
    return record;
  };

  const transformAfterFetch = (record) => {
    const transformed = {
      ...record,
      proyecto: record.proyecto
        ? {
            value: record.proyecto._id,
            label: record.proyecto.nombre,
          }
        : { label: "", value: "" },
      categoria: record.categoria
        ? {
            value: record.categoria._id,
            label: record.categoria.descripcion,
          }
        : { label: "", value: "" },
      moneda: record.moneda
        ? {
            value: record.moneda._id,
            label: record.moneda.simbolo,
          }
        : { label: "", value: "" },
      contratista: record.contratista
        ? {
            value: record.contratista._id,
            label: record.contratista.apellido + " " + record.contratista.nombre,
          }
        : { label: "", value: "" },
      estado: estadosPresupuestos.find((item) => item.label === record.estado),
    };
    return transformed;
  };

  const hookFetchData = async (id) => {
    try {
      if (id) {
        const [record, categs, mones, movs] = await Promise.all([
          getPresupuesto(id),
          getCategoriasSelect(),
          getMonedasSimboloSelect(),
          getMovimientosPresupuestos(id, false),
        ]);
        const [subproyectos] = await Promise.all([getSubProyectos(record.proyecto._id)]);
        setCategorias(categs);
        setMonedas(mones);
        setSubproyectos(subproyectos);
        console.log(movs);
        setMovimientos(movs);
        setPerc(movs.totalSinDocumentar + movs.totalDocumentado);
        setPercIva(movs.ivaFacturado);
        //   setCondicionesIva(condiciones); // for the <select>
        //   return transformAfterFetch(record, condiciones); // for the transform
        return transformAfterFetch(record);
      } else {
        const [categs, mones] = await Promise.all([getCategoriasSelect(), getMonedasSimboloSelect()]);
        setCategorias(categs);
        setMonedas(mones);
        return null;
      }
    } catch {
      history.replace("/noconnection");
    }
  };

  const onSave = async (data) => {
    // try {
    const savedRecord = await savePresupuesto(data);
    return savedRecord;
    // } catch (error) {
    //   throw error; // Rethrow the error to be handled by the caller
    // }
  };

  const handleChangeProyecto = async (proyecto) => {
    crudForm.data.proyecto = proyecto;
    const subproyectos = await getSubProyectos(proyecto.value);
    setSubproyectos(subproyectos);
  };

  const handleNewContratista = () => {
    window.open("/personas/nuevo_", "_blank");
  };

  const handleChangeAdicionales = (array) => {
    // const { data } = this.state;
    crudForm.data.adicionales = array;
    crudForm.setData({ ...crudForm.data });
  };

  const crudForm = useCrudForm({
    defaultPath: "/presupuestos",
    initialData,
    transformBeforeSave,
    onSave,
    schema: schema,
    onLoading: props.onLoading,
    onDoneLoading: props.onDoneLoading,
    hookFetchData,
    liveValidate: true,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    // // 1. Custom pre-processing the base hook doesn't know about.
    // if (crudForm.data.year && Number(crudForm.data.year) > new Date().getFullYear() + 1) {
    //   crudForm.setErrors({ year: "Year can't be in the future." });
    //   return;
    // }
    // const firstSave = crudForm.data._id ? false : true;
    // 2. Delegate to the base implementation (the "super" call).
    const ok = await crudForm.submit();

    // 3. Custom post-processing, only if the save succeeded.
    // if (ok) {
    //   if (firstSave) {
    //     const renewData = transFormAfterSave(crudForm.data, condicionesIva);
    //     console.log("renuredata");
    //     console.log(renewData);
    //     crudForm.setData(renewData);
    //   }
    // console.log("[analytics] car_saved", crudForm.data.make, crudForm.data.model);
    // alert("Car saved!");
    // }
  };

  let totalGeneral = 0;
  crudForm.data.adicionales.map((adicional) => {
    totalGeneral += formattedToFloat(adicional.monto);
  });
  const progress = (isNaN(perc / totalGeneral) ? 0 : perc / totalGeneral) * 100;
  const progressIva =
    (isNaN(percIva / ((totalGeneral * crudForm.data.iva) / 100))
      ? 0
      : percIva / ((totalGeneral * crudForm.data.iva) / 100)) * 100;
  let partialProgress = 0;
  let partialProgressIva = 0;

  console.log(movimientos);

  return (
    crudForm.data && (
      <CrudFormLayout
        title={title}
        crudForm={crudForm}
        breadcrumbs={breadcrumbs}
        onSubmit={handleSubmit} // note: our override, not crud.handleSubmit
        onCancel={onCancel}
        submitLabel="Guardar"
      >
        <div className="row">
          <Field crudForm={crudForm} label="Descripción" name="descripcion" float columns="12" />
        </div>
        <div className="row">
          <Field
            crudForm={crudForm}
            label="Proyecto"
            name="proyecto"
            type="asyncCombo"
            float
            columns="4"
            onChange={(event) => {
              handleChangeProyecto(event);
            }}
            promiseOptions={proyectosPromiseOptions}
          />
          <Field
            crudForm={crudForm}
            label="Subproyecto"
            name="subproyecto"
            type="combo"
            float
            columns="3"
            options={subproyectos}
          />
          <Field
            crudForm={crudForm}
            label="Contratista"
            name="contratista"
            columns="5"
            float
            asyncCreatable
            promiseOptions={personasPromiseOptions}
            onCreateOption={handleNewContratista}
          />
        </div>

        <div className="row">
          <Field
            crudForm={crudForm}
            label="Estados"
            name="estado"
            type="combo"
            float
            columns="4"
            options={estadosPresupuestos}
          />
          <Field
            crudForm={crudForm}
            label="Categoría"
            name="categoria"
            type="combo"
            float
            columns="3"
            options={categorias}
          />
          <Field crudForm={crudForm} label="Moneda" name="moneda" type="combo" float columns="1" options={monedas} />
          <Field crudForm={crudForm} label="% IVA Proyectado" name="iva" type="number" float columns="2" suffix="%" />
        </div>
        <div className="row mb-1">
          {
            <ChildArray
              data={crudForm.data.adicionales}
              blankItem={adicional}
              editable={crudForm.action === "C" ? false : true}
              format={adicionalesFormat}
              label="Adicional(es)"
              onChange={handleChangeAdicionales}
              onIsEditing={(isEditing) => crudForm.handleEditingChildArray(isEditing)}
            />
          }
        </div>
        <h4 className="mt-3">Evolución</h4>
        <h5 className="mt-2">Progreso Pagos</h5>
        <div className="row align-items-center mt-2 mb-5">
          <div className="col-10">
            <div className="progress progress-sm">
              <div
                className={
                  "progress-bar " + (progress < 33 ? "bg-danger" : progress < 66 ? "bg-warning" : "bg-success")
                }
                style={{ width: progress + "%" }}
              ></div>
              <ul className="marker-list">
                {progress > 0 &&
                  movimientos.pagos.map((pago) => {
                    partialProgress += pago.monto;
                    const partialPerc =
                      (isNaN(partialProgress / totalGeneral) ? 0 : partialProgress / totalGeneral) * 100;

                    return (
                      <OverlayTrigger
                        key={Math.random()}
                        placement="top"
                        overlay={
                          <Tooltip style={{ fontSize: "1.5rem" }}>
                            {pago.moneda +
                              " " +
                              numberWithCommas(pago.monto) +
                              " - " +
                              moment(pago.fecha).format("DD/MM/YYYY")}
                          </Tooltip>
                        }
                        delay={{ show: 250, hide: 400 }}
                      >
                        <li className="marker-light" style={{ left: partialPerc + "%" }}></li>
                      </OverlayTrigger>
                    );
                  })}
              </ul>
            </div>
          </div>
          <div className="col-2">
            <h4>{numberWithCommas(progress)} %</h4>
          </div>
        </div>
        <h5 className="mt-2">Progreso IVA</h5>
        <div className="row align-items-center mt-2 mb-5">
          <div className="col-10">
            <div className="progress progress-sm">
              <div
                className={
                  "progress-bar " + (progressIva < 33 ? "bg-danger" : progressIva < 66 ? "bg-warning" : "bg-success")
                }
                style={{ width: progressIva + "%" }}
              ></div>
              <ul className="marker-list">
                {progressIva > 0 &&
                  movimientos.pagosIva.map((pago) => {
                    partialProgressIva += pago.monto;
                    const partialPercIva =
                      (isNaN(partialProgressIva / ((totalGeneral * crudForm.data.iva) / 100))
                        ? 0
                        : partialProgressIva / ((totalGeneral * crudForm.data.iva) / 100)) * 100;

                    return (
                      <OverlayTrigger
                        key={Math.random()}
                        placement="top"
                        overlay={
                          <Tooltip style={{ fontSize: "1.5rem" }}>
                            {pago.moneda +
                              " " +
                              numberWithCommas(pago.monto) +
                              " - " +
                              moment(pago.fecha).format("DD/MM/YYYY")}
                          </Tooltip>
                        }
                        delay={{ show: 250, hide: 400 }}
                      >
                        <li className="marker-light" style={{ left: partialPercIva + "%" }}></li>
                      </OverlayTrigger>
                    );
                  })}
              </ul>
            </div>
          </div>
          <div className="col-2">
            <h4>{numberWithCommas(progressIva)} %</h4>
          </div>{" "}
        </div>

        <div class="row">
          <div class="col-12">
            <div id="accordion">
              <div class="card">
                <div class="card-header" id="headingOne">
                  <h4 class="mb-0">
                    <span
                      // class="btn btn-link"
                      data-toggle="collapse"
                      data-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      <i class="fa fa-caret-down" aria-hidden="true"></i> Detalles Pagos
                    </span>
                  </h4>
                </div>
                <div id="collapseOne" class="collapse " aria-labelledby="headingOne" data-parent="#accordion">
                  <div class="card-body">
                    <div className="row">
                      <div className="col-sm-12">
                        <table
                          id="datatable"
                          className="table table-bordered table-striped table-hover dataTable dtr-inline"
                          role="grid"
                          aria-describedby="datatable_info"
                        >
                          <thead>
                            <tr role="row">
                              <th>Fecha</th>
                              <th>Detalle</th>
                              <th>Forma de Pago</th>
                              {/* <th>Neto</th>
                              <th>Iva</th> */}
                              <th>Monto</th>
                            </tr>
                          </thead>
                          <tbody>
                            {movimientos.pagos &&
                              movimientos.pagos.map((mov) => (
                                <>
                                  <tr>
                                    <td>{moment(mov.fecha).format("DD/MM/YYYY")}</td>
                                    <td>{mov.detalle}</td>
                                    <td>
                                      {
                                        formasPago.find(
                                          (element) => element.value === (mov.formaPago ? mov.formaPago : "EFV"),
                                        ).label
                                      }
                                    </td>
                                    <td style={{ textAlign: "right" }}>{numberWithCommas(mov.monto)}</td>
                                  </tr>
                                </>
                              ))}
                          </tbody>
                          <tfoot>
                            <tr>
                              <td></td>
                              <td></td>
                              <td style={{ textAlign: "right" }}>
                                <strong>Total</strong>
                              </td>
                              <td style={{ textAlign: "right" }}>
                                {numberWithCommas(movimientos.totalDocumentado + movimientos.totalSinDocumentar)}
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-12">
            <FileBrowser
              status={crudForm.action}
              recordId={crudForm.data._id}
              serviceFolder={serviceFolder}
              filesUrl={filesUrl}
              canCreateFolder={true}
            />
          </div>
        </div>
      </CrudFormLayout>
    )
  );
}
